import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

type UrlData = {
    readonly notBulleted: string;
    readonly bulleted: string;
};

export class wmTextBulleted extends wmBase {
    public options: widgetOption[] = [];
    public urlData: UrlData | null | undefined = null;
    public isBulleted = false;

    constructor(options: widgetOption<boolean>[]) {
        super();
        this.options = options;
        this.urlData = {
            notBulleted: `
        <svg width="23" height="23" viewBox="0 0 98 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="37" y1="4" x2="94" y2="4" stroke="black" stroke-width="8" stroke-linecap="round"/>
        <line x1="4" y1="4" x2="16" y2="4" stroke="black" stroke-width="8" stroke-linecap="round"/>
        <line x1="37" y1="35" x2="94" y2="35" stroke="black" stroke-width="8" stroke-linecap="round"/>
        <line x1="4" y1="35" x2="16" y2="35" stroke="black" stroke-width="8" stroke-linecap="round"/>
        <line x1="37" y1="68" x2="94" y2="68" stroke="black" stroke-width="8" stroke-linecap="round"/>
        <line x1="4" y1="68" x2="16" y2="68" stroke="black" stroke-width="8" stroke-linecap="round"/>
        </svg>
      `,
            bulleted: `
        <svg width="23" height="23" viewBox="0 0 98 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="37" y1="4" x2="94" y2="4" stroke="white" stroke-width="8" stroke-linecap="round"/>
        <line x1="4" y1="4" x2="16" y2="4" stroke="white" stroke-width="8" stroke-linecap="round"/>
        <line x1="37" y1="35" x2="94" y2="35" stroke="white" stroke-width="8" stroke-linecap="round"/>
        <line x1="4" y1="35" x2="16" y2="35" stroke="white" stroke-width="8" stroke-linecap="round"/>
        <line x1="37" y1="68" x2="94" y2="68" stroke="white" stroke-width="8" stroke-linecap="round"/>
        <line x1="4" y1="68" x2="16" y2="68" stroke="white" stroke-width="8" stroke-linecap="round"/>
        </svg>
      `,
        };
    }

    public build(): string {
        const uniqValues = Array.from(new Set(this.options.map((o) => Boolean(o.value))));

        let selected = "";
        this.isBulleted = false;
        if (uniqValues.length === 1 && uniqValues[0]) {
            selected = "wm_textBulleted_selected";
            this.isBulleted = true;
        }

        const url =
            this.isBulleted && this.urlData
                ? this.urlData.bulleted
                : (this.urlData?.notBulleted ?? "");

        return `
            <div class="wm_textBulleted ${selected}">
                ${url}
            </div>
        `;
    }

    public init(): void {
        const item = document.getElementsByClassName("wm_textBulleted")[0] as HTMLElement;
        if (item) {
            item.removeEventListener("mouseup", this.itemClick.bind(this), false);
            item.addEventListener("mouseup", this.itemClick.bind(this), false);
        }
    }

    public itemClick(e: MouseEvent): void {
        const otherSubm = document.getElementsByClassName("widgetSubMenu")[0] as HTMLElement;
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        this.isBulleted = !this.isBulleted;

        this.applyValue(this.options, this.isBulleted);

        const menuItem = document.getElementsByClassName("wm_textBulleted")[0] as HTMLElement;
        if (menuItem && this.urlData) {
            if (this.isBulleted) {
                menuItem.classList.add("wm_textBulleted_selected");
                menuItem.innerHTML = this.urlData.bulleted;
            } else {
                menuItem.classList.remove("wm_textBulleted_selected");
                menuItem.innerHTML = this.urlData.notBulleted;
            }
        }
    }
}
